export const fetcher = url => fetch(url)
  .then(r => 
    r.json()
  )

export const host = domain ?? 'https://get.shop'


export const convertToCamelCase = (str) => str.split(' ').map( item => item[0].toUpperCase() + item.slice(1)).join(' ')